import { React, useEffect, useState } from "react";
import ToolsTab from "../../../components/toolsTab";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import VideoBanner from "../../../components/videoBanner";
import img_inventario_flora from "../../../assets/images/img_inventario_flora.svg";
import img_planta_inventario from "../../../assets/images/img_planta_inventario.png";
import img_banana_tree from "../../../assets/images/img_banana_tree.png";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const FloraInventoryScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const cielo = "5Ke8oY85S8M";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);
  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
        <div>
          <div className="w-full lg:h-[1080px]  absolute">
            <VideoBanner idVideo={cielo}></VideoBanner>
          </div>
          <div className="w-full mx-auto text-white relative h-fit   ">
            <div className="absolute right-0 mt-[21.6rem] mb-10 mr-72">
              <img
              
                src={img_banana_tree}
                className="lg:w-[40rem] md:w-[20rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
              ></img>
            </div>
            <div className="absolute right-0 mt-[48.5rem] w-[37rem] mb-10 ">
              <img
              
                src={img_planta_inventario}
                className="lg:w-[23rem] md:w-[15rem] sm:w-[15rem] w-[15rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible right-0 ml-40 absolute z-0 "
              ></img>
            </div>
            <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-black"
                borderType="border-b-2"
                borderColor="border-black"
                iconSize="h-5"
                iconColor=""
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
          <div className="text-left h-fit col-span-2 text-black lg:mr-10 sm:bottom-0 bg-white w-full z-10 relative">
                <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Árboles de plantas"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Inventario <br /> de flora
                    </h1>
                  }
                  text={
                    <div>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        El <b>inventario de flora</b> se lleva a cabo mediante
                        un muestreo al azar con transeptos de 100 x 10 m (1000
                        m2) en donde se identifican las especies de árboles
                        observadas. Este muestreo se puede complementar con
                        muestreos aleatorios en el bosque. Según el interés de
                        la empresa, se deben considerar especies de plantas
                        leñosas iguales o mayores a 5 m de altura, a 10 cm de
                        diámetro a la altura del pecho (DAP) y esencialmente con
                        un fuste principal definido. Si se desea un alcance
                        mayor, se pueden considerar hierbas, palmas, bejucos y
                        orquídeas. Además, el experto/a puede tomar muestras de 
                        aquellas plantas que necesitan una identificación en 
                        herbario. Estas muestras son cortes de ramas y hojas 
                        completas, con flores y frutos –de ser posible– que 
                        se prensan y secan para su posterior identificación.{" "}
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        La <b>identificación en campo</b> o basada en muestras
                        de plantas se lleva a cabo in situ por un experto/a en
                        la flora del sitio. Además, el experto/a puede tomar
                        muestras de aquellas plantas que necesitan una
                        identificación en herbario. Estas muestras son cortes de
                        ramas y hojas completas, con flores y frutos –de ser
                        posible– que se prensan y secan para su posterior
                        identificación.
                      </p>
                    </div>
                  }
                ></ToolsInfoSection>
                <img
                
                  src={img_inventario_flora}
                  className="px-52 w-full mb-[15rem]"
                ></img>
              </div>

              <div className="relative col-span-3 2xl:mt-[50rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className=" grid relative gap-0">
                  <div className="h-full relative">
                    <ToolsTab
                     firstTitle="Inventario de cuadrantes dentro y fuera de bosques"
                     secondTitle="Resultados y beneficios"
                      firstTab={
                        <p className="text-xl">
                          {" "}
                          Se recomienda realizar recorridos aleatorios en zonas no muestreadas con transeptos tanto dentro como fuera del bosque. En los recorridos aleatorios en zonas no muestreadas con los transeptos también se debe levantar un listado para hacer más robusto el listado general de los árboles y otras plantas presentes. Aquellas especies que no sean reconocidas en campo se identificarán mediante revisión de literatura especializada en la taxonomía de la flora de cada país y la comparación con muestras de herbarios.
                        </p>
                      }
                      secondTab={
                        <div>
                          <p className="text-xl mb-5">
                            Forma parte de la línea base de cualquier iniciativa
                            de monitoreo.
                          </p>
                          <p className="text-xl mb-5">
                            Implica un inventario que ayuda a definir el valor
                            paisajístico.
                          </p>
                          <p className="text-xl mb-5">
                            Se evidencia que las prácticas tienen un impacto
                            directo en el aumento de la diversidad.
                          </p>
                          <p className="text-xl mb-5">
                            Con esta información se puede diseñar la conexión
                            entre ambientes naturales y definir áreas para
                            conservación.
                          </p>
                        </div>
                      }
                    ></ToolsTab>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full absolute">
            <VideoBanner idVideo={cielo}></VideoBanner>
            <div className=" absolute right-0 lg:mr-64 md:mr-52 sm:mr-36 mr-20 lg:mb-20 md:mb-20 sm:mb-10 mb-10 bottom-0 ">
            <img
            
                src={img_banana_tree}
                className="lg:w-[20rem] md:w-[14rem] sm:w-[9rem] w-[9rem]"
              ></img>
            </div>
            <div className=" absolute  right-0 bottom-0">
            <img
            
                src={img_planta_inventario}
                className="lg:w-[20rem] md:w-[15rem] sm:w-[9rem] w-[9rem]"
              ></img>
            </div>
          </div>


          <div className="grid grid-cols-1  2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[25rem] md:mt-[20rem] sm:mt-[7rem] mt-[7rem] relative ">
            <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-black"
                borderType="border-b-2"
                borderColor="border-black"
                iconSize="h-5"
                iconColor=""
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              
            <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Aves"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Observación desde <br /> punto de vista fijo en 360 grados
                    </h1>
                  }
                  text={
                    <div>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        El <b>inventario de flora</b> se lleva a cabo mediante
                        un muestreo al azar con transeptos de 100 x 10 m (1000
                        m2) en donde se identifican las especies de árboles
                        observadas. Este muestreo se puede complementar con
                        muestreos aleatorios en el bosque. Según el interés de
                        la empresa, se deben considerar especies de plantas
                        leñosas iguales o mayores a 5 m de altura, a 10 cm de
                        diámetro a la altura del pecho (DAP) y esencialmente con
                        un fuste principal definido. Si se desea un alcance
                        mayor, se pueden considerar hierbas, palmas, bejucos y
                        orquídeas.{" "}
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        La <b>identificación en campo</b> o basada en muestras
                        de plantas se lleva a cabo in situ por un experto/a en
                        la flora del sitio. Además, el experto/a puede tomar
                        muestras de aquellas plantas que necesitan una
                        identificación en herbario. Estas muestras son cortes de
                        ramas y hojas completas, con flores y frutos –de ser
                        posible– que se prensan y secan para su posterior
                        identificación.
                      </p>
                    </div>
                  }
                ></ToolsInfoSection>
                <img
                
                  src={img_inventario_flora}
                  className="px-52 w-full mb-[15rem]"
                ></img>
            </div>



            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
            <ToolsTab
            firstTitle="Inventario de cuadrantes dentro y fuera de bosques"
            secondTitle="Resultados y beneficios"
                      firstTab={
                        <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                          {" "}
                          Se recomienda realizar recorridos aleatorios en zonas no muestreadas con transeptos tanto dentro como fuera del bosque. En los recorridos aleatorios en zonas no muestreadas con los transeptos también se debe levantar un listado para hacer más robusto el listado general de los árboles y otras plantas presentes. Aquellas especies que no sean reconocidas en campo se identificarán mediante revisión de literatura especializada en la taxonomía de la flora de cada país y la comparación con muestras de herbarios.
                        </p>
                      }
                      secondTab={
                        <div>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Forma parte de la línea base de cualquier iniciativa
                            de monitoreo.
                          </p>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Implica un inventario que ayuda a definir el valor
                            paisajístico.
                          </p>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Se evidencia que las prácticas tienen un impacto
                            directo en el aumento de la diversidad.
                          </p>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Con esta información se puede diseñar la conexión
                            entre ambientes naturales y definir áreas para
                            conservación.
                          </p>
                        </div>
                      }
                    ></ToolsTab>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FloraInventoryScreen;
